import React, { useCallback } from 'react'
import BaseContactInput from './BaseContactInput'
import { validateEmail } from '@/utils/validation'

interface EmailContactInputProps {
  isChecked: boolean
  onCheckboxChange: (e: React.ChangeEvent<HTMLInputElement>) => void
  email: string
  onEmailChange: (value: string, isValid: boolean) => void
  isSubmitting: boolean
  error?: string
}

const EmailContactInput: React.FC<EmailContactInputProps> = ({
  isChecked,
  onCheckboxChange,
  email,
  onEmailChange,
  isSubmitting,
  error
}) => {
  const handleEmailChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const value = e.target.value
      const isValid = value.trim() === '' ? true : validateEmail(value)
      onEmailChange(value, isValid)
    },
    [onEmailChange]
  )

  const handleBlur = useCallback(() => {
    if (isChecked) {
      const isValid = validateEmail(email)
      onEmailChange(email, isValid)
    }
  }, [isChecked, email, onEmailChange])

  return (
    <BaseContactInput
      id="email"
      label="Quiero que me contacten por correo electrónico"
      isChecked={isChecked}
      onCheckboxChange={onCheckboxChange}
      value={email}
      onChange={handleEmailChange}
      onBlur={handleBlur}
      error={error}
      isSubmitting={isSubmitting}
      inputProps={{
        type: 'email',
        placeholder: 'ejemplo@correo.com',
        autoComplete: 'email'
      }}
    />
  )
}

export default EmailContactInput
